/**
 * CheckoutChamp selector for the active Sel-2 product hero.
 * Shopify variants remain the source of display pricing and gallery handles.
 * CheckoutChamp offer IDs are used only to build the CTA redirect.
 */
(function () {
  'use strict';

  function parseJson(element) {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('[sel-2] Invalid selector JSON', error);
      return null;
    }
  }

  function formatMoney(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var format =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          '${{amount}}';
        return window.Shopify.formatMoney(value, format);
      } catch (error) {
        // Use the USD fallback below.
      }
    }

    return '$' + (value / 100).toFixed(2);
  }

  function getOptionValue(variant, position) {
    if (!variant || !position) return '';
    return String(variant['option' + position] || '').trim();
  }

  function toHandlePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildVariantHandle(variant) {
    if (!variant) return '';
    if (variant.image_filter_handle) return String(variant.image_filter_handle);

    return ['option1', 'option2', 'option3']
      .map(function (key) {
        return toHandlePart(variant[key]);
      })
      .filter(Boolean)
      .join('-');
  }

  function normalizeModel(value) {
    var model = String(value || '').toLowerCase();
    if (model.indexOf('plug') !== -1 || model.indexOf('non') !== -1) {
      return 'non-wireless';
    }
    if (model.indexOf('wireless') !== -1) return 'wireless';
    return '';
  }

  function normalizeSize(value) {
    var size = String(value || '').toLowerCase();
    if (size.indexOf('7') !== -1) return '7l';
    if (size.indexOf('4') !== -1) return '4l';
    return '';
  }

  function isPreferredGiftVariant(variant, bundlePosition) {
    if (!variant || !bundlePosition) return false;
    var value = getOptionValue(variant, bundlePosition).toLowerCase();
    return (
      value.indexOf('with') !== -1 &&
      (value.indexOf('gift') !== -1 || value.indexOf('dental') !== -1)
    );
  }

  function initializeSelector(wrapper) {
    if (!wrapper || wrapper.hasAttribute('data-sel-2-cc-bound')) return;

    var selector = wrapper.querySelector('[data-sel-2-checkout-selector]');
    var variantsData = parseJson(
      wrapper.querySelector('#sel-2-product-variants-data')
    );
    var checkoutConfig = parseJson(
      wrapper.querySelector('[data-sel-2-checkout-config]')
    );

    if (
      !selector ||
      !variantsData ||
      !Array.isArray(variantsData.variants) ||
      !variantsData.variants.length
    ) {
      return;
    }

    wrapper.setAttribute('data-sel-2-cc-bound', 'true');

    var variants = variantsData.variants;
    var stylePosition = Number(variantsData.style_position) || 1;
    var sizePosition = Number(variantsData.size_position) || 2;
    var bundlePosition = Number(variantsData.bundle_position) || 0;
    var selectedStyle = selector.getAttribute('data-selected-style') || '';
    var selectedSize = selector.getAttribute('data-selected-size') || '';

    function getSelectedValue(attribute) {
      var active = selector.querySelector('[' + attribute + '].is-active');
      return active ? active.getAttribute('data-option-value') || '' : '';
    }

    function syncStateFromDom() {
      selectedStyle = getSelectedValue('data-sel-2-cc-style') || selectedStyle;
      selectedSize = getSelectedValue('data-sel-2-cc-size') || selectedSize;
    }

    function matchingVariants(style, size) {
      return variants.filter(function (variant) {
        return (
          getOptionValue(variant, stylePosition) === String(style || '').trim() &&
          getOptionValue(variant, sizePosition) === String(size || '').trim()
        );
      });
    }

    function findVariant(style, size) {
      var matches = matchingVariants(style, size);
      if (!matches.length) return null;

      for (var index = 0; index < matches.length; index += 1) {
        if (isPreferredGiftVariant(matches[index], bundlePosition)) {
          return matches[index];
        }
      }

      return matches[0];
    }

    function selectedVariant() {
      return findVariant(selectedStyle, selectedSize);
    }

    function setText(selectorString, text) {
      var element = selector.querySelector(selectorString);
      if (element) element.textContent = text || '';
    }

    function setOptionalText(selectorString, text) {
      var element = selector.querySelector(selectorString);
      if (!element) return;
      element.textContent = text || '';
      element.hidden = !text;
    }

    function updateOptionPrices() {
      var styleOptions = selector.querySelectorAll('[data-sel-2-cc-style]');
      Array.prototype.forEach.call(styleOptions, function (option) {
        var style = option.getAttribute('data-option-value') || '';
        var variant = findVariant(style, selectedSize);
        var price = option.querySelector('[data-sel-2-cc-option-price]');
        var compare = option.querySelector('[data-sel-2-cc-option-compare]');

        if (price) {
          price.textContent = variant ? formatMoney(variant.price) : '';
        }

        if (compare) {
          var compareText =
            variant &&
            Number(variant.compare_at_price) > Number(variant.price)
              ? formatMoney(variant.compare_at_price)
              : '';
          compare.textContent = compareText;
          compare.hidden = !compareText;
        }
      });
    }

    function updateFountainImage() {
      var image = selector.querySelector('[data-sel-2-cc-fountain-image]');
      if (!image) return;

      var images =
        checkoutConfig && checkoutConfig.fountainImages
          ? checkoutConfig.fountainImages
          : null;
      if (!images) return;

      var isWireless = normalizeModel(selectedStyle) === 'wireless';
      var nextSrc = isWireless ? images.wireless : images.plugin;
      if (!nextSrc) return;

      image.src = nextSrc;
      image.removeAttribute('srcset');
      image.alt = '';
    }

    function updateIncludedAndSummary(variant) {
      if (!variant) return;

      var model = normalizeModel(selectedStyle) === 'wireless'
        ? 'Wireless'
        : 'Non-Wireless';
      var capacity = normalizeSize(selectedSize) === '7l' ? '7L' : '4L';
      var price = Number(variant.price) || 0;
      var compare = Number(variant.compare_at_price) || 0;
      var giftsValue = 5996;
      var totalCompare = Math.max(compare || price, price) + giftsValue;
      var savings = Math.max(totalCompare - price, 0);

      setText(
        '[data-sel-2-cc-fountain-title]',
        capacity + ' ' + model + ' Fountain'
      );
      setText('[data-sel-2-cc-fountain-price]', formatMoney(price));
      setOptionalText(
        '[data-sel-2-cc-fountain-compare]',
        compare > price ? formatMoney(compare) : ''
      );
      setText('[data-sel-2-cc-total-price]', formatMoney(price));
      setText('[data-sel-2-cc-total-compare]', formatMoney(totalCompare));
      setOptionalText(
        '[data-sel-2-cc-save]',
        savings > 0 ? 'SAVE ' + formatMoney(savings) : ''
      );
      updateFountainImage();
    }

    function updateHeroPriceAndCta(variant) {
      if (!variant) return;

      var currentPrice = formatMoney(variant.price);
      var comparePrice =
        Number(variant.compare_at_price) > Number(variant.price)
          ? formatMoney(variant.compare_at_price)
          : '';

      var currentElements = wrapper.querySelectorAll(
        '[data-sel-2-price-current]'
      );
      var compareElements = wrapper.querySelectorAll(
        '[data-sel-2-price-compare]'
      );

      Array.prototype.forEach.call(currentElements, function (element) {
        element.textContent = currentPrice;
        element.setAttribute('data-sel-2-price-cents', String(variant.price));
      });

      Array.prototype.forEach.call(compareElements, function (element) {
        element.textContent = comparePrice;
        element.hidden = !comparePrice;
        if (comparePrice) element.removeAttribute('hidden');
      });

      var button = wrapper.querySelector('[data-sel-2-atc-btn]');
      if (button) {
        var buttonPrice = button.querySelector('[data-sel-2-atc-price]');
        if (buttonPrice) {
          buttonPrice.textContent = currentPrice;
          buttonPrice.setAttribute('data-sel-2-price-cents', String(variant.price));
        }
      }

      syncCheckoutButtonHref();
    }

    function notifyGallery(variant) {
      if (!variant) return;

      document.dispatchEvent(
        new CustomEvent('sel-2:variant-change', {
          detail: {
            force: true,
            model: selectedStyle,
            size: selectedSize,
            bundle: getOptionValue(variant, bundlePosition),
            variant_handle: buildVariantHandle(variant)
          }
        })
      );
    }

    function updateSelection(options) {
      options = options || {};
      syncStateFromDom();
      var variant = selectedVariant();
      updateOptionPrices();
      updateIncludedAndSummary(variant);
      updateHeroPriceAndCta(variant);
      if (options.notifyGallery) notifyGallery(variant);
    }

    function selectOption(option, groupAttribute) {
      var options = selector.querySelectorAll('[' + groupAttribute + ']');
      Array.prototype.forEach.call(options, function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('is-active');
      option.setAttribute('aria-pressed', 'true');
      updateSelection({ notifyGallery: true });
    }

    selector.addEventListener('click', function (event) {
      var sizeOption = event.target.closest('[data-sel-2-cc-size]');
      var styleOption = event.target.closest('[data-sel-2-cc-style]');
      var guideTrigger = event.target.closest(
        '.sel-2-cc-selector__guide-trigger'
      );

      if (sizeOption && selector.contains(sizeOption)) {
        selectOption(sizeOption, 'data-sel-2-cc-size');
        return;
      }

      if (styleOption && selector.contains(styleOption)) {
        selectOption(styleOption, 'data-sel-2-cc-style');
        return;
      }

      if (guideTrigger && selector.contains(guideTrigger)) {
        var guide = guideTrigger.parentElement.querySelector(
          '.sel-2-cc-selector__guide'
        );
        if (!guide) return;
        var willOpen = guide.hidden;

        var guides = selector.querySelectorAll('.sel-2-cc-selector__guide');
        var triggers = selector.querySelectorAll(
          '.sel-2-cc-selector__guide-trigger'
        );
        Array.prototype.forEach.call(guides, function (item) {
          item.hidden = true;
        });
        Array.prototype.forEach.call(triggers, function (item) {
          item.setAttribute('aria-expanded', 'false');
        });

        guide.hidden = !willOpen;
        guideTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
    });

    document.addEventListener('click', function (event) {
      if (selector.contains(event.target)) return;
      var guides = selector.querySelectorAll('.sel-2-cc-selector__guide');
      var triggers = selector.querySelectorAll(
        '.sel-2-cc-selector__guide-trigger'
      );
      Array.prototype.forEach.call(guides, function (guide) {
        guide.hidden = true;
      });
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    function buildProductString(offer) {
      if (!offer || !offer.offerId) return '';
      var product = String(offer.offerId);
      if (offer.variantId) product += '.' + String(offer.variantId);
      return product + ':1';
    }

    function buildCheckoutUrl() {
      if (!checkoutConfig || !checkoutConfig.baseUrl) return '';

      var model = normalizeModel(selectedStyle);
      var size = normalizeSize(selectedSize);
      var mainOffer =
        checkoutConfig.mainOffers &&
        checkoutConfig.mainOffers[model + '|' + size];
      if (!mainOffer) return checkoutConfig.baseUrl;

      var products = [buildProductString(mainOffer)];
      var gifts = checkoutConfig.gifts || {};
      var replacement =
        gifts.replacementFilters && gifts.replacementFilters[model];

      [replacement, gifts.dentalBoost, gifts.oneYearGuarantee, gifts.fiveYearWarranty]
        .forEach(function (offer) {
          var productString = buildProductString(offer);
          if (productString) products.push(productString);
        });

      var checkoutUrl = new URL(checkoutConfig.baseUrl, window.location.origin);
      checkoutUrl.searchParams.set('products', products.join(';'));

      var currentParams = new URL(window.location.href).searchParams;
      currentParams.forEach(function (value, key) {
        var normalizedKey = String(key).toLowerCase();
        if (normalizedKey !== 'id' && normalizedKey !== 'products') {
          checkoutUrl.searchParams.append(key, value);
        }
      });

      return checkoutUrl.toString();
    }

    // Keep checkout URL on the native <a href> so GA4 can decorate with _gl.
    // Call this on selection changes only — never rewrite href during click
    // (that can strip GA4 linker decoration).
    function syncCheckoutButtonHref() {
      var ctaLink = wrapper.querySelector('a[data-sel-2-atc-btn][data-cta="checkout"]');
      if (!ctaLink) return;

      var redirectUrl = checkoutConfig && checkoutConfig.baseUrl
        ? checkoutConfig.baseUrl
        : '#';
      try {
        var built = buildCheckoutUrl();
        if (built) redirectUrl = built;
      } catch (error) {
        console.error('[sel-2] Error building CheckoutChamp URL:', error);
      }
      ctaLink.setAttribute('href', redirectUrl);
    }

    var cta = wrapper.querySelector('[data-sel-2-atc-btn]');
    if (cta) {
      // Native <a> navigation so GA4 cross-domain linker can decorate with _gl.
      // Clear any leftover JS redirect handlers; do not preventDefault on success.
      if (cta._handleSel2Checkout) {
        cta.removeEventListener('click', cta._handleSel2Checkout, true);
        delete cta._handleSel2Checkout;
      }
      cta.onclick = null;
      cta.removeAttribute('onclick');
      cta.removeAttribute('aria-disabled');
      cta.style.pointerEvents = '';

      function handleNativeCheckoutClick(event) {
        // Only block obviously broken links; otherwise let the browser navigate
        // so GA4 / GTM can observe the real <a href> click.
        var href = cta.getAttribute('href') || '';
        if (!href || href === '#') {
          if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
          }
          return;
        }

        var loading = wrapper.querySelector('[data-sel-2-atc-loading]');
        if (loading) {
          loading.classList.add('is-active');
          loading.setAttribute('aria-hidden', 'false');
        }
      }

      cta._handleSel2Checkout = handleNativeCheckoutClick;
      cta.addEventListener('click', handleNativeCheckoutClick, true);
      syncCheckoutButtonHref();
    }

    function initializeCountdown() {
      if (selector.hasAttribute('data-sel-2-cc-countdown-bound')) return;
      selector.setAttribute('data-sel-2-cc-countdown-bound', 'true');

      var storageKey = 'sel2CheckoutTimerEndAt';
      var duration = 12 * 60 * 60 * 1000;
      var endAt = 0;

      try {
        endAt = Number(localStorage.getItem(storageKey)) || 0;
      } catch (error) {
        endAt = 0;
      }

      if (endAt <= Date.now()) {
        endAt = Date.now() + duration;
        try {
          localStorage.setItem(storageKey, String(endAt));
        } catch (error) {
          // The countdown still works for this page view.
        }
      }

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function tick() {
        var remaining = endAt - Date.now();
        if (remaining <= 0) {
          endAt = Date.now() + duration;
          remaining = duration;
          try {
            localStorage.setItem(storageKey, String(endAt));
          } catch (error) {
            // Ignore local storage failures.
          }
        }

        var totalSeconds = Math.floor(remaining / 1000);
        setText('[data-sel-2-cc-day]', pad(Math.floor(totalSeconds / 86400)));
        setText(
          '[data-sel-2-cc-hour]',
          pad(Math.floor((totalSeconds % 86400) / 3600))
        );
        setText(
          '[data-sel-2-cc-minute]',
          pad(Math.floor((totalSeconds % 3600) / 60))
        );
        setText('[data-sel-2-cc-second]', pad(totalSeconds % 60));
      }

      tick();
      window.setInterval(tick, 1000);
    }

    initializeCountdown();
    updateSelection({ notifyGallery: false });
  }

  function initializeSocialProof() {
    var elements = document.querySelectorAll('[data-sel-2-social-count]');
    if (!elements.length) return;

    var storageKey = 'sel2DogParentsCounterV2';
    var state;
    try {
      state = JSON.parse(localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      state = null;
    }

    var now = Date.now();
    if (!state || !state.startedAt || now - state.startedAt >= 86400000) {
      state = {
        count: Math.floor(Math.random() * 201) + 400,
        startedAt: now,
        updatedAt: now
      };
    }

    var elapsedSteps = Math.floor((now - state.updatedAt) / 300000);
    if (elapsedSteps > 0) {
      state.count += elapsedSteps * 3;
      state.updatedAt += elapsedSteps * 300000;
    }

    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      // Rendering does not depend on local storage.
    }

    Array.prototype.forEach.call(elements, function (element) {
      element.textContent = String(state.count);
    });
  }

  function formatUsShipDate(daysAhead) {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    var parts = formatter.formatToParts(new Date());
    var year = 0;
    var month = 0;
    var day = 0;
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].type === 'year') year = Number(parts[i].value);
      if (parts[i].type === 'month') month = Number(parts[i].value);
      if (parts[i].type === 'day') day = Number(parts[i].value);
    }

    var ship = new Date(Date.UTC(year, month - 1, day + (daysAhead || 2)));
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'short',
      month: 'short',
      day: '2-digit'
    }).format(ship);
  }

  function initializeShippingBars() {
    var dates = document.querySelectorAll('[data-sel-2-ship-date]');
    if (dates.length) {
      var label = formatUsShipDate(2);
      Array.prototype.forEach.call(dates, function (element) {
        element.textContent = label;
      });
    }
    initializeShippingFlags();
  }

  function countryCodeToFlag(code) {
    if (!code || typeof code !== 'string' || code.length !== 2) return '🇺🇸';
    var upper = code.toUpperCase();
    if (!/^[A-Z]{2}$/.test(upper)) return '🇺🇸';
    return String.fromCodePoint(
      127397 + upper.charCodeAt(0),
      127397 + upper.charCodeAt(1)
    );
  }

  function applyShippingFlags(countryCode) {
    var flags = document.querySelectorAll('[data-sel-2-ship-flag]');
    if (!flags.length) return;
    var emoji = countryCodeToFlag(countryCode);
    Array.prototype.forEach.call(flags, function (element) {
      element.textContent = emoji;
      element.setAttribute('aria-label', String(countryCode || 'US').toUpperCase());
    });
  }

  function resolveVisitorCountryCode() {
    var storageKey = 'sel2VisitorCountryCodeV1';

    try {
      var cached = sessionStorage.getItem(storageKey);
      if (cached && /^[A-Za-z]{2}$/.test(cached)) {
        return Promise.resolve(cached.toUpperCase());
      }
    } catch (error) {
      // Continue without cache.
    }

    return fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('browsing context lookup failed');
        return response.json();
      })
      .then(function (data) {
        var detected = data && data.detected_values ? data.detected_values : null;
        var code =
          (detected && detected.country && detected.country.handle) ||
          (window.Shopify && Shopify.country) ||
          'US';
        code = String(code || 'US');
        if (!/^[A-Za-z]{2}$/.test(code)) code = 'US';
        code = code.toUpperCase();
        try {
          sessionStorage.setItem(storageKey, code);
        } catch (error) {
          // Ignore storage failures.
        }
        return code;
      })
      .catch(function () {
        try {
          if (window.Shopify && typeof Shopify.country === 'string' && Shopify.country.length === 2) {
            return Shopify.country.toUpperCase();
          }
        } catch (error) {
          // Fall through.
        }
        return 'US';
      });
  }

  function initializeShippingFlags() {
    var flags = document.querySelectorAll('[data-sel-2-ship-flag]');
    if (!flags.length) return;
    resolveVisitorCountryCode().then(applyShippingFlags);
  }

  function initialize() {
    var wrappers = document.querySelectorAll('[data-sel-2-product-selector]');
    Array.prototype.forEach.call(wrappers, initializeSelector);
    initializeSocialProof();
    initializeShippingBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
